module.exports = __webpack_public_path__ + "static/img/Who We Are.66e5f3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/Who We Are.png
// module id = aj7Y
// module chunks = 0